import React from 'react'

const ViewAssortment = () => {
  return (
    <div>ViewAssortment</div>
  )
}

export default ViewAssortment